import gql from "graphql-tag";

const GET_9141_FORM_DATA = gql`
  query getForm9141AById($id: String!) {
    getForm9141ById(id: $id) {
      formVersionId
      payload {
        visaType
        requestorPocLastName
        requestorPocFirstName
        requestorPocMiddleName
        requestorPocJobTitle
        requestorPocAddr1
        requestorPocAddr2
        requestorPocCity
        requestorPocState
        requestorPocPostalCode
        requestorPocCountry
        requestorPocProvince
        requestorPocPhone
        requestorPocPhoneExt
        requestorPocFaxNumber
        requestorPocEmail

        empBusinessName
        empTradeName
        empAddr1
        empAddr2
        empCity
        empState
        empPostcode
        empCountry
        empProvince
        empPhone
        empPhoneext
        empFein
        empNaics
        empNaicsDesc

        attyRepresentType
        attyLastname
        attyFirstname
        attyMiddlename
        attyAddr1
        attyAddr2
        attyCity
        attyState
        attyPostcode
        attyCountry
        attyProvince
        attyPhone
        attyPhoneext
        attyEmail
        attyBizname
        attyFein

        coveredByAcwia
        coveredByAcwiaFiles
        acwiaHigherEdu
        acwiaAffiliated
        acwiaNonprofit
        acwiaStatusChange
        sportsLeague
        sportsLeagueOrganizationFiles
        sportsLeagueLetterFiles
        sportsLeagueUnionFiles
        cba
        cbaFiles
        cbaEmployerLetterFiles
        cbaUnionLetterFiles
        pre_dbaSca
        dbaSca
        dbaSurvey
        surveyName
        surveyPublicationDate
        surveyFiles
        surveyFormEta9165Files

        jobTitle
        jobDuties
        jobDutiesFiles
        superviseOtherEmp
        supervisedSocs {
          supervisedSocCode
          supervisedSocTitle
          sort_order
        }

        primaryEducationLevel
        otherEducation
        major
        secondDiploma
        secondDiplomaMajor
        trainingRequired
        numberOfMonthsTraining
        nameRequiredTraining
        empExperienceRequired
        empExperienceMonths
        occupationRequired
        specialRequirements
        isSpecialRequirements
        isSpecReqLicenseCert
        specReqLicenseCert
        isSpecReqForeignLang
        specReqForeignLang
        isSpecReqResFellow
        specReqResFellow
        isSpecReqOther
        specReqOther

        altJobRequirement
        altEducationLevel
        altOtherEdu
        altMajor
        altTrainingReq
        altNumMonthsTraining
        altNameReqdTraining
        altEmpExperienceReqd
        altEmpExpNumMonths
        isAltSpecialReq
        isAltSpecReqLicenseCert
        altSpecReqLicenseCert
        isAltSpecReqForeignLang
        altSpecReqForeignLang
        isAltSpecReqResFellow
        altSpecReqResFellow
        isAltSpecReqOther
        altSpecReqOther

        suggestedSocCode
        suggestedSocTitle
        supervisorJobTitle
        travelRequired
        travelDetails

        primaryWorksiteAddr1
        primaryWorksiteAddr2
        primaryWorksiteCity
        primaryWorksiteCounty {
          label
          value
        }
        primaryWorksiteBlsArea
        primaryWorksiteState
        primaryWorksitePostalCode
        otherWorksiteLocation

        otherWorksites {
          worksiteCity
          worksiteState
          worksitePostalCode
          worksiteCountyTownship {
            label
            value
          }
          worksiteCountyOrBlsArea
          worksiteBlsArea {
            label
            value
          }
          worksiteBlsAreaId
          sort_order
          error
        }

        files {
          machine_name
          application_id
          FileType
          fileType
          document_name
          size
          displayName
          lastModified
          state
          percentage
          document_path
        }
      }
      form_ui {
        pages_visited
        pages_errors
      }
    }
  }
`;

const SUBMIT_9141_FORM = gql`
  mutation SubmitForm9141(
    $id: String!
    $Form9141FormData: Form9141FormData!
    $token: String
  ) {
    SubmitForm9141(Form9141FormData: $Form9141FormData, id: $id, token: $token)
  }
`;

const UPDATE_9141_FORM = gql`
  mutation updateForm9141ById(
    $id: String!
    $Form9141FormData: Form9141FormData!
    $formUI9141: formUIInput
    $profilePrefillMetadata: [ProfilePrefillMetadataInput!]
  ) {
    updateForm9141ById(
      id: $id
      Form9141FormData: $Form9141FormData
      formUI9141: $formUI9141
      profilePrefillMetadata: $profilePrefillMetadata
    )
  }
`;

const GET_PROFILES_9141 = gql`
  query {
    getUserProfileInfo {
      EmployerProfiles {
        employer_id
        employer_name
      }
      EmployerPOCProfiles {
        employer_poc_id
        employer_poc_name
      }
      AgentIndividualProfiles {
        agent_ind_id
        agent_ind_name
      }
    }
  }
`;

export {
  GET_9141_FORM_DATA,
  UPDATE_9141_FORM,
  SUBMIT_9141_FORM,
  GET_PROFILES_9141,
};
